import React from "react";

const RightChevron = () => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.17275 5.00008L0.34375 2.17208L1.75775 0.75708L6.00075 5.00008L1.75775 9.24308L0.34375 7.82808L3.17275 5.00008Z"
      fill="currentColor"
    />
  </svg>
);

export default RightChevron;
